import { IRootState } from '@app/state';
import { get } from 'lodash';
import { TState } from './state';

export const createSelectors = (slicePath: string) => {
  const getSlice = (state: IRootState): TState => get(state, slicePath);

  return {};
};
